import "./editCheque.scss";
import {useEffect, useState} from "react";
import { toast } from "react-toastify";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { FaToEnDigits } from "../../utils/faToEnDigits";
import { useFormFields } from "../../hooks/useFormFields";
import { EditCheque } from "../../services/chequeService";
import DateChooser from "../dateChooser/dateChooser";
import TextInput from "../textInput/textInput";
import IconButton from "../iconButton/iconButton"
import BankSelectList from "../bankSelectList/bankSelectList";
import CheckIcon from "../../assets/images/check.svg";
import CloseIcon from "../../assets/images/closeCancel.svg";

export default function EditChequeComponent({cheque, afterEditCheque, onCancel}) {
  const [loading, setLoading] = useState(false);
  let { fields, handleFields } = useFormFields({
      bankName: cheque.bankName,
      chequeNumber: cheque.chequeNumber,
      sayadNumber: cheque.sayadNumber,
      dueDate: new DateObject({ date: String(cheque.dueDate), calendar: persian, locale: persian_fa}),
      amount: new Intl.NumberFormat("fa-IR").format(Number(cheque.amount)),
      owner: cheque.owner,
      ownerNationalCode: cheque.ownerNationalCode,
      reason: cheque.reason,
      reminderDate: new DateObject({ date: String(cheque.reminderDate), calendar: persian, locale: persian_fa}),
    });

  const handleDates = (e) => {
    fields["dueDate"] = e;
    handleFields(new DateObject({
      date: e.valueOf(),
      calendar: persian,
      locale: persian_fa,
    }).subtract(1, "day"), "reminderDate");
  }

  const editCheque =  async (id) => {
    const payload = {...fields}
    var pureAmount = payload.amount.replace(/[٬,]/g, "");
    payload["amount"] = pureAmount.replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    payload["amount"] = parseInt(payload.amount)
    if (Object.values(payload).every((value) => value !== "")) {
      if (payload.amount > 0) {
        try {
          payload["dueDate"] = FaToEnDigits(payload.dueDate.format("YYYYMMDD"));
          payload["reminderDate"] = FaToEnDigits(payload.reminderDate.format("YYYYMMDD"));
          setLoading(true);
          await EditCheque(id, payload);
          setLoading(false);
          afterEditCheque();
          } catch (err) {
            setLoading(false);
            toast.error(err.error, { toastId: "error" });
          }
      } else {
        toast.error("مبلغ چک صحیح نیست", { toastId: "error" });
      }
    } else {
       toast.error("وارد کردن تمامی موارد الزامی است", { toastId: "error" });
    }
  }

  return (
    <div className="editCheque form">
      <div className="chequeRows">
        <div className="chequeRow">
          <BankSelectList onChange={(e) => handleFields(e, "bankName")} selectedValue={fields.bankName} />
        </div>
        <div className="chequeRow">
          <TextInput
            label={"شماره چک"}
            val={fields.chequeNumber}
            onChange={(e) => handleFields(e, "chequeNumber")}  
            direction={"ltr"}
          />
        </div>
        <div className="chequeRow">
          <TextInput
            label={"شماره چک"}
            val={fields.sayadNumber}
            onChange={(e) => handleFields(e, "sayadNumber")}  
            direction={"ltr"}
          />
        </div>
        <div className="chequeRow">
          <DateChooser label="تاریخ:" date={fields.dueDate} setDate={(e) => handleDates(e)} minDate={0} inputWidth="160px" />
        </div>
        <div className="chequeRow">
          <TextInput
            label={"مبلغ"}
            val={fields.amount}
            onChange={(e) => handleFields(e, "amount")}  
            validation="amount"
            direction={"ltr"}
          />
        </div>
        <div className="chequeRow">
          <TextInput
            label={"در وجه"}
            val={fields.owner}
            onChange={(e) => handleFields(e, "owner")}  
          />
        </div>
        <div className="chequeRow">
          <TextInput
            label={"کد/شناسه ملی"}
            val={fields.ownerNationalCode}
            onChange={(e) => handleFields(e, "ownerNationalCode")}
            direction={"ltr"}
          />
        </div>
        <div className="chequeRow">
          <TextInput
            label={"بابت"}
            val={fields.reason}
            onChange={(e) => handleFields(e, "reason")}  
          />
        </div>
        <div className="chequeRow">
          <DateChooser label="تاریخ یادآوری:" date={fields.reminderDate} setDate={(e) => handleFields(e, "reminderDate")} minDate={0} maxDate={fields.dueDate} inputWidth="160px" />
        </div>
      </div>
      <div className="editChequeIconWrapper">
        <IconButton icon={CheckIcon} tooltip="ثبت" onClick={() => editCheque(cheque.ID)} loading={loading} className="editChequeButton" />
        <IconButton icon={CloseIcon} tooltip="بیخیال" onClick={() => onCancel()} className="editChequeButton" />
      </div>
      {/* <IconButton icon={EnterIcon} loading={loading} tooltip="ثبت" onClick={() => addCheque()}  /> */}
    </div>
  );
}
